export default __webpack_public_path__ + "static/media/002-like.e3eab538.png";